import { useCallback, useState } from 'react';

import { Feature } from 'config/features';

import { useFeature } from 'hooks/useFeature';

import {
    departureAirportAtom,
    departureDateAtom,
    destinationAtom,
    returnDateAtom,
    travelDurationAtom,
} from 'data/Atom/Search';
import { formStore } from 'data/Atom/Store';

import { DurationType, ValidationType } from 'types/Search/form';

export const useFormValidation = () => {
    const isS1S4MandatoryActive = useFeature(Feature.S1S4Mandatory);
    const [isFormValidate, setIsFormValidate] = useState({
        isDestinationEmpty: false,
        isDepartureAirportEmpty: false,
        isTravelDatesEmpty: false,
        isDurationEmpty: false,
    });

    const onValidateItem = useCallback(
        (type: ValidationType, isEmpty: boolean) => {
            switch (type) {
                case ValidationType.Destination:
                    setIsFormValidate({
                        ...isFormValidate,
                        isDestinationEmpty: isS1S4MandatoryActive && isEmpty,
                    });
                    break;
                case ValidationType.DepartureAirport:
                    setIsFormValidate({
                        ...isFormValidate,
                        isDepartureAirportEmpty:
                            isS1S4MandatoryActive && isEmpty,
                    });
                    break;
                case ValidationType.TravelDates:
                    setIsFormValidate({
                        ...isFormValidate,
                        isTravelDatesEmpty: isEmpty,
                    });
                    break;
                case ValidationType.Duration:
                    setIsFormValidate({
                        ...isFormValidate,
                        isDurationEmpty: isEmpty,
                    });
                    break;
            }
        },
        [isFormValidate, isS1S4MandatoryActive]
    );

    const onValidateForm = useCallback(() => {
        setIsFormValidate({
            isDestinationEmpty:
                isS1S4MandatoryActive && !formStore.get(destinationAtom).label,
            isDepartureAirportEmpty:
                isS1S4MandatoryActive &&
                formStore.get(departureAirportAtom).size === 0,
            isTravelDatesEmpty:
                !formStore.get(returnDateAtom) ||
                !formStore.get(departureDateAtom),
            isDurationEmpty:
                formStore.get(travelDurationAtom).type === DurationType.Empty,
        });
    }, [isS1S4MandatoryActive]);

    const isSubmitPossible = () => {
        const hasTravelPeriodData =
            formStore.get(travelDurationAtom).type !== DurationType.Empty &&
            !!formStore.get(departureDateAtom) &&
            !!formStore.get(returnDateAtom);

        return (
            (!isS1S4MandatoryActive && hasTravelPeriodData) ||
            (formStore.get(departureAirportAtom).size > 0 &&
                !!formStore.get(destinationAtom).label &&
                hasTravelPeriodData)
        );
    };

    return { isFormValidate, onValidateItem, onValidateForm, isSubmitPossible };
};
